export const verifyErrorMessaging = {
  400: 'Invalid Phone Number. Please verify that your phone number is correct.',
  401: 'Invalid Code.',
  429: 'Too many attempts. Please call us 1-800-750-4014.',
}
